import"inter-ui/inter.css";import{css as Nn}from"styled-components";var Q={gray:{gray1:"#17181C",gray2:"#1A1B1F",gray3:"#1E1F24",gray4:"#202127",gray5:"#23242A",gray6:"#25272D",gray7:"#27292F",gray8:"#2E3038",gray9:"#3C3F48",gray10:"#4A4D59",gray11:"#9A9DAD",gray12:"#EDEEF0"},blue:{blue1:"#131620",blue2:"#151A2D",blue3:"#192140",blue4:"#1C264F",blue5:"#1F2B5C",blue6:"#22316E",blue7:"#273B89",blue8:"#2F49B2",blue9:"#3E5EDD",blue10:"#5371E7",blue11:"#849DFF",blue12:"#EEF1FD"},red:{red1:"#1F1315",red2:"#291415",red3:"#3C181A",red4:"#481A1D",red5:"#541B1F",red6:"#822025",red7:"#AA2429",red8:"#AA2429",red9:"#E5484D",red10:"#F2555A",red11:"#FF6369",red12:"#FEECEE"},green:{green1:"#0D1912",green2:"#0C1F17",green3:"#0F291E",green4:"#113123",green5:"#133929",green6:"#164430",green7:"#1B543A",green8:"#236E4A",green9:"#30A46C",green10:"#3CB179",green11:"#4CC38A",green12:"#E5FBEB"},yellow:{yellow1:"#1F1300",yellow2:"#271700",yellow3:"#341C00",yellow4:"#3F2200",yellow5:"#4A2900",yellow6:"#573300",yellow7:"#693F05",yellow8:"#824E00",yellow9:"#FFB224",yellow10:"#FFCB47",yellow11:"#F1A10D",yellow12:"#FEF3DD"},violet:{violet1:"#17151F",violet2:"#1C172B",violet3:"#251E40",violet4:"#2C2250",violet5:"#32275F",violet6:"#392C72",violet7:"#392C72",violet8:"#5842C3",violet9:"#6E56CF",violet10:"#7C66DC",violet11:"#9E8CFC",violet12:"#F1EEFE"}},Ko={...Q.gray,...Q.blue,...Q.red,...Q.green,...Q.yellow,...Q.violet,black:"#000000",white:"#FFFFFF"},Jo={gray50:"#FAFAFA",gray100:"#F4F4F5",gray200:"#E3E4E8",gray300:"#C2C4CC",gray400:"#9DA1AE",gray500:"#6B6F80",gray600:"#4F525E",gray700:"#2F3138",gray800:"#26282E",gray850:"#1E1F24",gray900:"#17181C",red400:"#F87171",red500:"#EF4444",green400:"#34D399",green500:"#10B981",blue400:"#5F8FF5",blue500:"#477FF7",blue600:"#3170F7",purple400:"#C084FC",purple500:"#A855F7",yellow400:"#FBBF24",yellow500:"#F59E0B",black:"#000000",white:"#FFFFFF"};var qo='"Inter var", "system-ui"',Qo='"Fira Code", monospace';var on={fontStyle:"normal",WebkitFontSmoothing:"antialiased",MozOsxFontSmoothing:"grayscale"},O={...on,fontFamily:qo,fontWeight:400},xe={...O,fontFamily:Qo},oe={...O,fontWeight:500},A={...O,fontWeight:600},tn={...O,fontSize:"12px",lineHeight:"18px"},rn={...O,fontSize:"13px",lineHeight:"18px"},nn={...O,fontWeight:450,fontSize:"13px",lineHeight:"18px"},an={...O,fontSize:"14px",lineHeight:"20px"},sn={...O,fontWeight:450,fontSize:"14px",lineHeight:"20px"},pn={...O,fontSize:"16px",lineHeight:"24px"},ln={...O,fontWeight:450,fontSize:"16px",lineHeight:"24px"},cn={...O,fontSize:"18px",lineHeight:"26px"},dn={...O,fontWeight:450,fontSize:"18px",lineHeight:"26px"},mn={...O,fontSize:"20px",lineHeight:"30px"},fn={...oe,fontSize:"13px",lineHeight:"19.5px"},gn={...oe,fontSize:"14px",lineHeight:"20px"},un={...oe,fontSize:"16px",lineHeight:"24px"},yn={...oe,fontSize:"18px",lineHeight:"26px"},xn={...oe,fontSize:"20px",lineHeight:"28px"},bn={...oe,fontSize:"26px",lineHeight:"30px"},hn={...xe,fontSize:"11px",lineHeight:"15.4px"},Pn={...xe,fontSize:"12px",lineHeight:"16.8px"},Tn={...xe,fontSize:"13px",lineHeight:"20px"},In={...xe,fontSize:"14px",lineHeight:"19.6px"},Cn={...xe,fontSize:"16px",lineHeight:"22.4px"},Sn={...A,fontSize:"16px",lineHeight:"20px"},wn={...A,fontSize:"18px",lineHeight:"22.5px",letterSpacing:"-0.01em"},$n={...A,fontSize:"20px",lineHeight:"25px",letterSpacing:"-0.01em"},vn={...A,fontSize:"24px",lineHeight:"30px",letterSpacing:"-0.01em"},Rn={...A,fontSize:"32px",lineHeight:"36.8px",letterSpacing:"-0.02em"},kn={...A,fontSize:"40px",lineHeight:"46px",letterSpacing:"-0.02em"},Mn={...A,fontSize:"48px",lineHeight:"55.2px",letterSpacing:"-0.02em"},Dn={...A,fontSize:"56px",lineHeight:"61.6px",letterSpacing:"-0.02em"},Bn={...A,fontSize:"64px",lineHeight:"70.4px",letterSpacing:"-0.02em"},Fn={...A,fontSize:"14px",lineHeight:"21px",letterSpacing:"-0.02em"},zn={...A,fontSize:"16px",lineHeight:"24px",letterSpacing:"-0.02em"},En={text2Xs:tn,textXs:rn,textXsPlus:nn,textSm:an,textSmPlus:sn,textBase:pn,textBasePlus:ln,textLg:cn,textLgPlus:dn,textXl:mn},On={headingXs:fn,headingSm:gn,headingBase:un,headingLg:yn,headingXl:xn,headingBIGXL:bn},Ln={titleBase:Sn,titleLg:wn,titleXl:$n,title2Xl:vn,title3Xl:Rn,title4Xl:kn,title5Xl:Mn,title6Xl:Dn,title7Xl:Bn,titleCapsSm:Fn,titleCapsBase:zn},An={mono3Xs:hn,mono2Xs:Pn,monoXs:Tn,monoSm:In,monoBase:Cn},ee={fontFamily:{primary:qo,secondary:Qo},fontWeight:{normal:400,bold:500,title:600},styleSet:{text:En,heading:On,title:Ln,mono:An}},co={...ee.styleSet.text,...ee.styleSet.heading,...ee.styleSet.title,...ee.styleSet.mono};var et={sm:"0px 1px 2px rgba(0, 0, 0, 0.05)",base:"0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px -1px rgba(0, 0, 0, 0.1)",md:"0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -2px rgba(0, 0, 0, 0.1)",lg:"0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -4px rgba(0, 0, 0, 0.1)"};var ot={xs:425,sm:640,md:768,lg:1024,xl:1280};var tt={s0:"0rem",s1:"0.25rem",s2:"0.5rem",s3:"0.75rem",s4:"1rem",s5:"1.25rem",s6:"1.5rem"};var rt={xxxs:10,xxs:12,xs:13,sm:14,base:16,lg:18,xl:24};var mo={colors:{...Ko,...Jo},typography:ee,styleSet:Object.keys(co).reduce((e,o)=>({...e,[o]:Nn(co[o])}),{}),spacing:tt,shadows:et,breakpoints:ot,iconSizes:rt};import{ThemeProvider as Vn,createGlobalStyle as Hn,useTheme as Wn}from"styled-components";import{jsx as _n,jsxs as Un}from"react/jsx-runtime";var Gn=({children:e,theme:o=mo,...t})=>Un(Vn,{...t,theme:o,children:[_n(Xn,{}),e]}),be=Wn;var Xn=Hn`
  *, *:after, *:before {
    box-sizing: border-box;
  }

  /* TODO: should use @radix-ui/react-scroll-area */
  ::-webkit-scrollbar {
    display: none;
  }
`;import{forwardRef as jn}from"react";import Zn,{css as Yn}from"styled-components";import{jsx as Jn}from"react/jsx-runtime";var m=jn(({variant:e="textBase",color:o="inherit",tag:t,...r},n)=>Jn(Kn,{ref:n,...r,$color:o,$variant:e,as:t}));var Kn=Zn.span`
  ${({theme:e,$variant:o="textBase",$color:t="inherit"})=>{let r=e.colors[t]??t;return Yn`
      ${e.styleSet[o]};
      color: ${r};
      text-decoration-color: ${r};
      text-decoration: none;
      margin: unset;
      width: fit-content;
      cursor: inherit;
    `}};
`;import{forwardRef as qn}from"react";import at,{css as fo}from"styled-components";import{FontAwesomeIcon as Qn}from"@fortawesome/react-fontawesome";import{jsx as ke}from"react/jsx-runtime";var y=qn(({className:e,icon:o,size:t="xs",color:r="inherit",spin:n,...a},i)=>{let s=be();if(typeof o=="string"){let p=/^(fas|far|fal|fat|fad|fab|fak)-(.+)$/.exec(o);if(p){let[c,d,u]=p;return ke(nt,{$size:t,className:e,ref:i,children:ke(it,{...a,$spin:n,color:s.colors[r]??r,icon:[d,u]})})}return null}return ke(nt,{$size:t,className:e,ref:i,children:ke(it,{...a,$spin:n,color:s.colors[r]??r,icon:o})})});var nt=at.div`
  ${({theme:e,$size:o="xs"})=>{let t=`${typeof o=="number"?o:e.iconSizes[o]}px`;return fo`
      display: flex;
      justify-content: center;
      align-items: center;
      aspect-ratio: 1/1;
      flex-shrink: 0;
      white-space: nowrap;
      height: ${t};
      width: ${t};
    `}}
`,it=at(Qn)`
  ${({$spin:e})=>fo`
    width: 100%;
    height: 100%;

    ${e?fo`
          animation: spin infinite 1s linear;

          @keyframes spin {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(360deg);
            }
          }
        `:void 0}
  `}
`;import{forwardRef as ei}from"react";import{Slot as oi}from"@radix-ui/react-slot";import ti,{css as ri}from"styled-components";import{jsx as st}from"react/jsx-runtime";var fd=ei(({children:e,asChild:o,variant:t="textSm",color:r="blue11",newWindow:n,...a},i)=>st(ni,{$color:r,$variant:t,...a,target:n?"_blank":a.target,onClick:a.onClick,ref:i,children:o?e:st("a",{children:e})}));var ni=ti(oi)`
  ${({theme:e,$color:o="blue11",$variant:t="textSm"})=>{let r=e.colors[o]??o;return ri`
      ${e.styleSet[t]};

      color: ${r};
      text-decoration-color: ${r};

      text-decoration: none;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    `}}
`;import{forwardRef as ii}from"react";import lt,{css as pt}from"styled-components";import{jsx as go}from"react/jsx-runtime";var hd=ii(({name:e,imageSrc:o,size:t,bgColor:r,...n},a)=>go(ai,{ref:a,...n,$bgColor:r,$size:t,children:o?go(si,{alt:"avatar",src:o}):e?go(m,{color:"gray12",tag:"label",variant:"textSmPlus",children:e.trim().charAt(0).toUpperCase()}):null}));var ai=lt.div`
  ${({theme:e,$size:o=28,$bgColor:t="gray9",onClick:r})=>pt`
      display: inline-flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0px;
      width: ${o}px;
      height: ${o}px;
      border-radius: 50%;
      background-color: ${e.colors[t]??t};
      user-select: none;
      overflow: hidden;
      white-space: normal;
      flex-shrink: 0;

      ${r&&pt`
        cursor: pointer;
        &:hover {
          background-color: ${e.colors.gray10};
        }
      `}
    `}
`,si=lt.img`
  aspect-ratio: 1/1;
  width: 100%;
  height: 100%;
`;import{forwardRef as pi}from"react";import li,{css as ci}from"styled-components";import ct from"chroma-js";var $=(e="",o=1)=>ct.valid(e)?ct(e).alpha(o).css():"inherit";import{jsx as dt}from"react/jsx-runtime";var Rd=pi(({children:e,color:o="gray11",textVariant:t="textSm",...r},n)=>dt(di,{...r,$color:o,ref:n,children:dt(m,{color:o,tag:"label",variant:t,children:e})}));var di=li.div`
  ${({theme:e,$color:o})=>ci`
    display: flex;
    flex-direction: row;
    flex: 0;
    align-items: flex-start;
    padding: 0px 6px;
    gap: 4px;
    width: fit-content;
    white-space: nowrap;
    border-radius: 4px;
    background-color: ${$(e.colors[o],.08)};
  `}
`;import{forwardRef as mi}from"react";import uo,{css as De}from"styled-components";import{jsx as Me,jsxs as xi}from"react/jsx-runtime";var fi=mi(({icon:e,imgSrc:o,svg:t,spin:r,innerSize:n="xs",...a},i)=>{if(e||o||t)return Me(fi,{...a,ref:i,children:e?Me(y,{color:a.color,icon:e,size:n,spin:r}):Me(yi,{$size:n,$spin:r,alt:"svg-boxed-icon",src:o??t})});let{children:s,dimension:l="36px",statusColor:p,color:c,...d}=a;return xi(gi,{$color:c,$dimension:l,...d,ref:i,children:[s,p?Me(ui,{$color:p}):null]})});var gi=uo.div`
  ${({theme:e,$dimension:o,$color:t="gray11"})=>De`
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0px;
    isolation: isolate;
    box-sizing: border-box;
    flex-shrink: 0;
    white-space: nowrap;
    border-radius: 8px;
    overflow: hidden;

    width: ${o};
    height: ${o};

    color: ${e.colors[t]??t};
    background-color: ${e.colors.gray3};
    box-shadow: inset 0 0 0 1px ${e.colors.gray7};

    &:hover {
      background-color: ${e.colors.gray4};
      box-shadow: inset 0 0 0 1px ${e.colors.gray8};
    }
  `}
`,ui=uo.div`
  ${({theme:e,$color:o="gray11"})=>De`
      position: absolute;
      width: 8px;
      height: 8px;
      left: 19px;
      top: 19px;
      border-radius: 50%;
      box-shadow: inset 0 0 0 1px ${e.colors.gray1};
      background-color: ${e.colors[o]};
    `}
`,yi=uo.img`
  ${({theme:e,$size:o="xs",$spin:t})=>{let r=`${typeof o=="number"?o:e.iconSizes[o]}px`;return De`
      height: ${r};
      width: ${r};
      max-height: ${r};
      max-width: ${r};

      ${t?De`
            animation: spin infinite 1s linear;

            @keyframes spin {
              from {
                transform: rotate(0deg);
              }
              to {
                transform: rotate(360deg);
              }
            }
          `:void 0}
    `}}
`;import Di from"styled-components";import{forwardRef as bi}from"react";import hi,{css as k}from"styled-components";import{jsx as Si,jsxs as wi}from"react/jsx-runtime";var Pi={secondary:"gray",primary:"blue",danger:"red",success:"green",info:"violet"},Ti=bi(({children:e,buttonTheme:o="primary",variant:t="solid",size:r="sm",text:n,icon:a,width:i,height:s,...l},p)=>wi(Ci,{...l,$height:s,$size:r,$themeColor:Pi[o],$variant:t,ref:p,style:{width:i,height:s,...l.style},children:[a?Si(y,{icon:a,size:"xs"}):null,n??e]})),B=Ti,Ii={sm:{fontVariant:"textSmPlus",height:"36px",gap:"8px",padding:"0px 12px"},lg:{fontVariant:"headingBase",height:"48px",gap:"12px",padding:"0px 16px"}},Ci=hi.button`
  ${({theme:e,$themeColor:o,$variant:t,$size:r})=>{let{fontVariant:n="textSmPlus",...a}=Ii[r],i=k`
      display: inline-flex;
      white-space: nowrap;
      flex-shrink: 0;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      min-width: fit-content;
      width: max-content;
      box-sizing: border-box;
      border-radius: 8px;
      overflow: hidden;
      cursor: pointer;

      /* SIZE */
      ${e.styleSet[n]};
      ${k(a)};
      ${t==="inline"&&k`
        height: initial;
        padding: initial;
        border-radius: initial;
      `};

      &:disabled {
        pointer-events: none;
        opacity: 0.5;
      }
    `,s=k`
      ${t==="solid"&&k`
        background-color: ${e.colors[`${o}9`]};
        &:hover,
        &:active {
          background-color: ${e.colors[`${o}10`]};
        }
      `};
      ${t==="outline"&&k`
        background-color: ${e.colors[`${o}3`]};
        &:hover {
          background-color: ${e.colors[`${o}4`]};
        }
        &:active {
          background-color: ${e.colors[`${o}5`]};
        }
      `};
      ${t==="ghost"&&k`
        &:hover {
          background-color: ${e.colors[`${o}4`]};
        }
        &:active {
          background-color: ${e.colors[`${o}5`]};
        }
      `};
    `,l=k`
      ${t==="outline"&&k`
        box-shadow: inset 0 0 0 1px ${e.colors[`${o}7`]};
        &:hover,
        &:active {
          box-shadow: inset 0 0 0 1px ${e.colors[`${o}8`]};
        }
      `};
      ${t==="ghost"&&k`
        &:hover,
        &:active {
          box-shadow: inset 0 0 0 1px ${e.colors[`${o}8`]};
        }
      `};
    `,p=k`
      ${t==="solid"&&k`
        color: ${e.colors[`${o}12`]};
      `};
      ${t==="outline"&&k`
        color: ${o==="gray"?e.colors[`${o}12`]:e.colors[`${o}11`]};
      `};
      ${t==="ghost"&&k`
        color: ${e.colors[`${o}11`]};
        &:hover,
        &:active {
          color: ${o==="gray"?e.colors[`${o}12`]:e.colors[`${o}11`]};
        }
      `};
      ${t==="inline"&&k`
        color: ${e.colors[`${o}11`]};
        &:hover,
        &:active {
          color: ${e.colors[`${o}12`]};
        }
      `};
    `;return k`
      all: unset;
      ${i};
      ${s};
      ${l};
      ${p};
    `}}
`;import{forwardRef as $i}from"react";import vi from"styled-components";import{jsx as mt}from"react/jsx-runtime";var Ri={xs:"xs",sm:"xs"},ki=$i(({icon:e,size:o="sm",...t},r)=>mt(Mi,{ref:r,...t,children:mt(y,{icon:e,size:Ri[o]})})),F=ki,Mi=vi(B)`
  text-align: center;
  padding: 0;
  aspect-ratio: 1/1;
  width: unset;
`;var Zd=Di.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 0px;
  gap: 8px;
  width: max-content;
`;import{forwardRef as Bi}from"react";import Fe,{css as ft}from"styled-components";import{Root as Fi,Portal as zi,Overlay as Ei,Content as Oi,DialogTrigger as Li}from"@radix-ui/react-dialog";import{jsx as Be,jsxs as Vi}from"react/jsx-runtime";var gt=Bi(({container:e,children:o,trigger:t,open:r,onOpenChange:n,maxWidth:a,minWidth:i="400px",zIndex:s,...l},p)=>Vi(Fi,{onOpenChange:n,open:r,children:[t?Be(Li,{asChild:!0,children:t}):void 0,Be(zi,{container:e,children:Be(Ai,{$zIndex:s,children:Be(Ni,{...l,$maxWidth:a,$minWidth:i,ref:p,children:o})})})]}));var Ai=Fe(Ei)`
  ${({$zIndex:e})=>ft`
      position: fixed;
      background-color: rgba(14, 14, 17, 0.8);
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: grid;
      place-items: center;
      overflow-y: auto;
      animation: overlayShow 150ms cubic-bezier(0.16, 1, 0.3, 1);
      z-index: ${e??"auto"};

      @keyframes overlayShow {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }
    `}
`,Ni=Fe(Oi)`
  ${({theme:e,$minWidth:o,$maxWidth:t})=>ft`
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      box-sizing: border-box;
      color: ${e.colors.gray12};
      background-color: ${e.colors.gray1};
      border: 1px solid ${e.colors.gray6};
      box-shadow: ${e.shadows.base};
      min-width: ${o};
      max-width: ${t};
      border-radius: 8px;
      overflow: hidden;
      outline: none;

      animation: contentShow 150ms cubic-bezier(0.16, 1, 0.3, 1);

      @keyframes contentShow {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }
    `}
`,tm=Fe.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px 24px;
  width: 100%;
`,rm=Fe.div`
  display: flex;
  width: 100%;
  border-top: 1px solid ${e=>e.theme.colors.gray6};
  padding: ${e=>e.theme.spacing.s5};
`;import{forwardRef as Hi}from"react";import yt,{css as Wi}from"styled-components";import{faTimes as Gi}from"@fortawesome/pro-regular-svg-icons";import{jsx as ut,jsxs as Ui}from"react/jsx-runtime";var dm=Hi(({children:e,title:o,onClose:t,...r},n)=>Ui(Xi,{ref:n,...r,$withCloseButton:!!t,children:[ut(_i,{children:e??o}),t?ut(F,{buttonTheme:"secondary",icon:Gi,onClick:t,variant:"outline"}):null]}));var Xi=yt.div`
  ${({theme:e,$withCloseButton:o})=>Wi`
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: ${o?"12px 24px":"20px 24px"};
      box-sizing: border-box;
      gap: 10px;
      border-bottom: 1px solid ${e.colors.gray6};
      width: 100%;
    `}
`,_i=yt(m).attrs({tag:"h3",variant:"textSmPlus",color:"gray12"})``;import{forwardRef as ji}from"react";import Zi,{css as Yi}from"styled-components";import{jsx as Ji}from"react/jsx-runtime";var xm=ji(({placement:e="right",...o},t)=>Ji(Ki,{maxWidth:"640px",...o,$placement:e,ref:t}));var xt={left:"translate3d(-100%,0,0)",right:"translate3d(100%,0,0)"},Ki=Zi(gt)`
  && {
    ${({$placement:e="right"})=>Yi`
        position: fixed;
        border-radius: 0;
        z-index: auto;
        width: 100%;
        overflow-y: scroll;

        top: 0;
        bottom: 0;
        left: ${e==="left"?0:void 0};
        right: ${e==="right"?0:void 0};

        will-change: transform;

        &[data-state="open"] {
          animation: slideIn 150ms cubic-bezier(0.22, 1, 0.36, 1);
        }

        &[data-state="close"] {
          animation: slideOut 150ms cubic-bezier(0.22, 1, 0.36, 1);
        }

        @keyframes slideIn {
          from {
            transform: ${xt[e]};
          }
          to {
            transform: translate3d(0, 0, 0);
          }
        }

        @keyframes slideOut {
          from {
            transform: translate3d(0, 0, 0);
          }
          to {
            transform: ${xt[e]};
          }
        }
      `}
  }
`;import*as H from"@radix-ui/react-dropdown-menu";import te,{css as yo}from"styled-components";var bt=te(H.Root)``,he=te(H.Group)`
  padding: 4px 0;
  width: 100%;
`,ht=te(H.Content)`
  ${({theme:e,$minWidth:o,$maxHeight:t})=>yo`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 4px;
    box-sizing: border-box;
    background-color: ${e.colors.gray2};
    box-shadow:
      ${e.shadows.sm},
      inset 0 0 0 1px ${e.colors.gray6};
    border-radius: 8px;
    min-width: ${o??"auto"};
    max-height: ${t};
    overflow-y: auto;

    ${he}:first-child {
      padding-top: 0;
    }

    ${he}:last-child {
      padding-bottom: 0;
    }

    ${he}:not(:last-child) {
      border-bottom: 1px solid ${e.colors.gray6};
    }
  `}
`,Pt=te(H.Item)`
  ${({theme:e,$textColor:o="gray12"})=>yo`
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 8px;
      width: 100%;
      box-sizing: border-box;
      gap: 10px;
      user-select: none;
      outline: none;
      border-radius: 8px;
      ${e.styleSet.textSmPlus};
      color: ${e.colors[o]};
      cursor: pointer;

      &:hover {
        background-color: ${e.colors.gray4};
      }
    `}
`,Tt=te.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`,It=te(H.Trigger)`
  ${e=>!e.asChild&&yo`
      all: unset;
    `}
`;import{jsx as qi}from"react/jsx-runtime";var ze=e=>qi(bt,{...e});import{forwardRef as bo}from"react";import Ct,{css as Qi}from"styled-components";import{faAngleDown as ea}from"@fortawesome/pro-regular-svg-icons";import{jsx as Pe,jsxs as ta}from"react/jsx-runtime";var re=bo((e,o)=>Pe(It,{...e,ref:o})),Ee=bo(({width:e,children:o,color:t="gray12",...r},n)=>ta(oa,{...r,$width:e,ref:n,children:[Pe(m,{color:t,tag:"span",variant:"textSmPlus",children:o}),Pe(xo,{color:"gray11",icon:ea,size:"sm"})]})),ho=bo(({children:e,...o},t)=>Pe(re,{...o,asChild:!0,ref:t,children:Pe(Ee,{color:"gray12",children:e})}));var xo=Ct(y)``,oa=Ct.button`
  ${({theme:e,$width:o})=>Qi`
      all: unset;

      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 8px 12px;
      box-sizing: border-box;
      gap: 8px;
      background: ${e.colors.gray3};
      box-shadow:
        ${e.shadows.base},
        inset 0 0 0 1px ${e.colors.gray7};
      border-radius: 8px;

      cursor: pointer;
      width: ${o??"initial"};

      ${xo} {
        transition: transform 200ms linear;
      }

      &[data-state="open"] {
        ${xo} {
          transform: rotate(180deg);
        }
      }
    `}
`;import{forwardRef as ra}from"react";import{jsx as na}from"react/jsx-runtime";var Em=ra((e,o)=>na(he,{...e,ref:o}));import{forwardRef as ia}from"react";import{Portal as aa}from"@radix-ui/react-dropdown-menu";import{jsx as St}from"react/jsx-runtime";var Oe=ia(({container:e,maxHeight:o,minWidth:t,...r},n)=>St(aa,{container:e,children:St(ht,{sideOffset:5,...r,$maxHeight:o,$minWidth:t,ref:n})}));import{forwardRef as sa}from"react";import{jsx as wt,jsxs as $t}from"react/jsx-runtime";var Le=sa(({children:e,leadingIcon:o,trailingIcon:t,textColor:r,onClick:n,...a},i)=>$t(Pt,{...a,$textColor:r,onClick:s=>{s.stopPropagation(),n&&n(s)},ref:i,children:[$t(Tt,{children:[o?wt(y,{color:"gray11",icon:o,size:"xs"}):null,e]}),t?wt(y,{color:"gray11",icon:t,size:"xs"}):null]}));import{forwardRef as Te}from"react";import ie,{css as pa}from"styled-components";import{Table as la,TableHead as ca,TableBody as da,TableRow as ma,TableCell as fa}from"@mui/material";import{jsx as ne}from"react/jsx-runtime";var rf=Te(({layout:e="auto",bgColor:o="gray2",border:t=!0,...r},n)=>ne(ga,{children:ne(ua,{...r,$bgColor:o,ref:n,style:{tableLayout:e,border:t?void 0:"none",...r.style}})})),nf=Te((e,o)=>ne(ya,{...e,ref:o})),af=Te((e,o)=>ne(xa,{...e,ref:o})),sf=Te(({height:e,...o},t)=>ne(ba,{...o,$height:e,ref:t})),pf=Te(({padding:e="12px 20px",...o},t)=>ne(ha,{...o,ref:t,style:{padding:e,...o.style}}));var ga=ie.div`
  position: relative;
  box-sizing: border-box;
  background-clip: padding-box;
  width: 100%;
  max-width: 100%;
  overflow: auto;
`,ua=ie(la)`
  && {
    ${({theme:e,$bgColor:o})=>pa`
      height: fit-content;
      width: 100%;
      table-layout: fixed;
      background-color: ${e.colors[o]??o};
      border: 1px solid ${e.colors.gray6};
      border-radius: 8px;
      border-collapse: separate !important;
      overflow: hidden;

      // This entire segment of CSS properties here is to make sure that the last
      // row of a table does not have a border-bottom (it looks bad)
      th {
        ${e.styleSet.textSmPlus};
        color: ${e.colors.gray11};
        border-bottom: 1px solid ${e.colors.gray6};
      }

      td {
        ${e.styleSet.textSm};
        color: ${e.colors.gray11};
        border-bottom: 1px solid ${e.colors.gray6};
      }

      tr:last-child > td {
        border-bottom: none;
      }
    `}
  }
`,ya=ie(ca)`
  && {
    th {
      padding: 16px 20px;
    }
  }
`,xa=ie(da)`
  && {
    td {
      padding: 12px 20px;
    }
  }
`,ba=ie(ma)`
  ${({$height:e})=>e?`height: ${e}`:""};
`,ha=ie(fa)`
  && {
    border: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: ${e=>e.theme.colors.gray11};
  }
`;import{useEffect as Pa,useState as Ta}from"react";import{jsx as Po,jsxs as Ia}from"react/jsx-runtime";var vt=({className:e,placeholder:o="Select...",defaultValue:t,value:r,options:n=[],triggerWidth:a="auto",disabled:i,onChange:s,...l})=>{let[p,c]=Ta(0);Pa(()=>{let g=r??t;if(g!=null){let P=Math.max(0,Math.min(n.length-1,n.findIndex(T=>T.value===g)));c(P)}},[r,t,n]);let d=g=>()=>{c(g),s==null||s(n[g].value)},[u,f]=n.length>0&&p>=0&&p<n.length?[n[p].label??n[p].value,"gray12"]:[o,"gray11"];return Ia(ze,{children:[Po(ho,{className:e,color:f,disabled:i,width:a,children:u}),n.length>0&&Po(Oe,{sideOffset:5,...l,children:n.map(({value:g,label:P,...T},v)=>Po(Le,{...T,onSelect:d(v),children:P??g},v))})]})};import{forwardRef as Ca}from"react";import Y,{css as Rt}from"styled-components";import{jsx as Da}from"react/jsx-runtime";var xf=Ca(({type:e="body-gray",text:o,children:t,...r},n)=>{let i={"mono-blue":Sa,"mono-gray":wa,"mono-green":ka,"mono-purple":Ma,"body-gray":$a,"body-purple":va,"body-blue":Ra}[e];return Da(i,{...r,ref:n,children:t??o})});var K=Rt`
  border-radius: 4px;
  height: max-content;
  width: max-content;
  ${e=>e.onClick&&Rt`
      cursor: pointer;
      :hover {
        opacity: 0.8;
      }
    `}
`,Sa=Y.div`
  ${e=>e.theme.styleSet.mono2Xs};
  color: white;
  background-color: ${e=>e.theme.colors.blue500};
  padding: 2px 4px 2px 4px;
  ${K}
`,wa=Y.div`
  ${e=>e.theme.styleSet.mono2Xs};
  color: ${e=>e.theme.colors.gray300};
  background-color: ${e=>e.theme.colors.gray700};
  padding: 2px 4px 2px 4px;
  ${K}
`,$a=Y.div`
  ${e=>e.theme.styleSet.text2Xs};
  color: ${e=>e.theme.colors.gray11};
  background-color: ${e=>e.theme.colors.gray7};
  padding: 1px 8px 1px 8px;
  ${K}
`,va=Y.div`
  ${e=>e.theme.styleSet.text2Xs};
  color: white;
  background-color: ${e=>e.theme.colors.purple500};
  padding: 1px 8px 1px 8px;
  ${K}
`,Ra=Y.div`
  ${e=>e.theme.styleSet.text2Xs};
  color: white;
  background-color: ${e=>e.theme.colors.blue500};
  padding: 1px 8px 1px 8px;
  ${K}
`,ka=Y.div`
  ${e=>e.theme.styleSet.mono2Xs};
  color: ${e=>e.theme.colors.white};
  background-color: ${e=>e.theme.colors.green500};
  padding: 2px 4px 2px 4px;
  ${K}
`,Ma=Y.div`
  ${e=>e.theme.styleSet.mono2Xs};
  color: white;
  background-color: ${e=>e.theme.colors.purple500};
  padding: 2px 4px 2px 4px;
  ${K}
`;import{forwardRef as ae}from"react";import Ne,{css as To}from"styled-components";import{Input as Ba,inputClasses as Ae}from"@mui/base/Input";import{TextareaAutosize as Fa}from"@mui/base/TextareaAutosize";import{faSearch as za}from"@fortawesome/pro-regular-svg-icons";import{jsx as W}from"react/jsx-runtime";var Ea=ae(({fullWidth:e,width:o,ownerState:t,style:r,...n},a)=>W(Aa,{...n,ref:a,style:{width:e?"100%":o,...r}})),Oa=ae(({ownerState:e,...o},t)=>W(Na,{...o,ref:t})),La=ae(({ownerState:e,...o},t)=>W(Va,{...o,ref:t})),Mt=({inputRef:e,width:o,fullWidth:t,slots:r,onKeyDown:n,...a})=>W(Ba,{...a,fullWidth:t,onKeyDown:i=>{i.key==="Enter"&&i.preventDefault(),n==null||n(i)},slotProps:{root:{style:{height:a.multiline?void 0:"36px"}},input:{ref:e}},slots:{root:Ea,input:Oa,textarea:La,...r},width:o}),Io=ae(({startAdornment:e,endAdornment:o,...t},r)=>W(Mt,{...t,endAdornment:o?W(kt,{style:{paddingRight:"12px"},children:o}):void 0,inputRef:r,startAdornment:e?W(kt,{style:{paddingLeft:"12px"},children:e}):void 0})),vf=ae((e,o)=>W(Io,{...e,ref:o,startAdornment:W(y,{icon:za,size:"xs"}),type:"search"})),Rf=ae(({rows:e,minRows:o,maxRows:t,...r},n)=>W(Mt,{...r,inputRef:n,maxRows:e??t,minRows:e??o,multiline:!0}));var Aa=Ne.div`
  ${({theme:e})=>To`
      outline: none;
      border: none;

      ${e.styleSet.textSm};

      position: relative;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      box-sizing: border-box;
      width: 100%;
      overflow: hidden;

      background-color: ${e.colors.gray3};
      border: 1px solid ${e.colors.gray7};
      border-radius: 8px;
      color: ${e.colors.gray12};

      &:hover {
        background-color: ${e.colors.gray4};
        border: 1px solid ${e.colors.gray8};
      }

      &.${Ae.disabled} {
        color: ${e.colors.gray11};
      }

      &.${Ae.focused} {
        background-color: ${e.colors.gray4};
        border: 1px solid ${e.colors.blue9};
        box-shadow: 0px 0px 0px 2px ${e.colors.blue7};
      }

      &.${Ae.error} {
        color: ${e.colors.red11};

        &.${Ae.focused} {
          border: 1px solid ${e.colors.red9};
          box-shadow: 0px 0px 0px 2px ${$(e.colors.red7,.25)};
        }
      }
    `}
`,Dt=To`
  ${({theme:e})=>To`
    font: inherit;
    padding: 8px 12px;
    flex-grow: 1;
    background: inherit;
    border: none;
    border-radius: inherit;
    color: inherit;
    outline: 0;

    &::placeholder {
      color: ${e.colors.gray11};
    }

    &:disabled {
      opacity: 0.5;
    }
  `}
`,Na=Ne.input`
  ${Dt};

  &[type="search"]::-webkit-search-cancel-button {
    -webkit-appearance: none;
  }
`,Va=Ne(Fa)`
  ${Dt};
  resize: vertical;
`,kt=Ne.div`
  display: flex;
  height: 100%;
  box-sizing: border-box;
  align-items: center;
`;import{forwardRef as Bt}from"react";import Ha,{css as Wa}from"styled-components";import{Root as Ga,Item as Xa,Indicator as _a}from"@radix-ui/react-radio-group";import{faCheck as Ua}from"@fortawesome/pro-solid-svg-icons";import{jsx as Ve}from"react/jsx-runtime";var Of=Bt(({style:e,gap:o="12px",...t},r)=>Ve(Ga,{...t,ref:r,style:{gap:o,display:"flex",flexDirection:"column",...e}})),Lf=Bt((e,o)=>Ve(ja,{...e,ref:o,children:Ve(_a,{children:Ve(y,{color:"gray12",icon:Ua,size:"xxxs"})})}));var ja=Ha(Xa)`
  ${({theme:e})=>Wa`
      all: unset;
      display: flex;
      width: 13px;
      height: 13px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      border-radius: 13px;
      border-style: solid;
      border-width: 1.25px;
      border-color: ${e.colors.gray9};

      &:hover {
        border-color: ${e.colors.gray10};
        background-color: ${e.colors.gray4};
      }

      &[data-state="checked"] {
        border-color: ${e.colors.blue9};
        background-color: ${e.colors.blue9};

        &:hover {
          border-color: ${e.colors.blue10};
          background-color: ${e.colors.blue10};
        }
      }
    `}
`;import{forwardRef as Za,useState as Ya}from"react";import Ka,{css as Ja}from"styled-components";import{Root as qa,Indicator as Qa}from"@radix-ui/react-checkbox";import{faCheck as es,faMinus as os}from"@fortawesome/pro-solid-svg-icons";import{jsx as Co,jsxs as rs}from"react/jsx-runtime";var _f=Za(({checked:e,onCheckedChange:o,...t},r)=>{let[n,a]=Ya(e);return Co(ts,{...t,checked:n,onCheckedChange:s=>{a(s),o&&o(s)},ref:r,children:rs(Qa,{children:[n===!0&&Co(y,{color:"white",icon:es,size:"xxxs"}),n==="indeterminate"&&Co(y,{color:"white",icon:os,size:"xxxs"})]})})});var ts=Ka(qa)`
  ${({theme:e})=>Ja`
      all: unset;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 13px;
      height: 13px;

      border-radius: 4px;
      border-width: 1.25px;
      border-style: solid;

      &[data-state="unchecked"] {
        background-color: transparent;
        border-color: ${e.colors.gray9};

        &:hover {
          background-color: ${e.colors.gray4};
          border-color: ${e.colors.gray10};
        }

        &[data-disabled] {
          opacity: 0.5;
          background-color: transparent;
          border-color: ${e.colors.gray9};
        }
      }

      &[data-state="checked"],
      &[data-state="indeterminate"] {
        background-color: ${e.colors.blue9};
        border-color: ${e.colors.blue9};

        &:hover {
          background-color: ${e.colors.blue10};
          border-color: ${e.colors.blue10};
        }

        &[data-disabled] {
          background-color: ${e.colors.gray9};
          border-color: ${e.colors.gray9};
        }
      }

      &[data-disabled] {
        opacity: 0.5;
      }
    `}
`;import{forwardRef as ss}from"react";import We from"styled-components";import{faCircleInfo as ps}from"@fortawesome/pro-regular-svg-icons";import{forwardRef as ns}from"react";import zt,{css as is}from"styled-components";import*as L from"@radix-ui/react-tooltip";import{jsx as se,jsxs as Ft}from"react/jsx-runtime";var Et=ns(({header:e,description:o,children:t,...r},n)=>{let{defaultOpen:a,open:i,onOpenChange:s,delayDuration:l=250,disableHoverableContent:p,container:c,arrow:d,placement:u,...f}=r,g={defaultOpen:a,open:i,onOpenChange:s,delayDuration:l,disableHoverableContent:p},P=typeof d=="boolean"?d&&{}:d;return se(L.TooltipProvider,{children:Ft(L.Root,{...g,children:[se(L.Trigger,{asChild:!0,children:t}),se(L.Portal,{container:c,children:Ft(as,{sideOffset:5,side:u,...f,ref:n,children:[e?se(m,{color:"gray12",tag:"h6",variant:"headingXs",children:e}):null,o?se(m,{color:"gray12",tag:"p",variant:"textXs",children:o}):null,P?se(Ot,{...P}):null]})})]})})});var as=zt(L.Content)`
  ${({theme:e})=>is`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 4px;
    box-sizing: border-box;
    padding: 8px;
    border-radius: 6px;
    box-shadow: ${e.shadows.sm};
    background-color: ${e.colors.gray8};

    ${Ot} {
      fill: ${e.colors.gray8};
    }
  `}
`,Ot=zt(L.Arrow)``;import{jsx as He,jsxs as Lt}from"react/jsx-runtime";var At=ss(({gap:e="24px",maxWidth:o,style:t,...r},n)=>He(ls,{...r,ref:n,style:{gap:e,maxWidth:o,...t}})),pe=({children:e,label:o,maxWidth:t,info:r,id:n,...a})=>Lt(cs,{...a,style:{maxWidth:t,...a.style},children:[o?Lt(ds,{children:[He(ms,{id:n,children:o}),r?He(Et,{description:r,placement:"right",children:He(y,{color:"gray11",icon:ps,size:"xxs"})}):null]}):null,e]});var ls=We.form`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  box-sizing: border-box;
  width: 100%;
`,cs=We.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 12px;
  width: 100%;
`,ds=We.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`,ms=We(m).attrs({tag:"label",variant:"textSmPlus",color:"gray12"})``;import{forwardRef as fs,useMemo as gs}from"react";import Vt,{css as us}from"styled-components";import{faInfoCircle as ys}from"@fortawesome/pro-regular-svg-icons";import{jsx as So,jsxs as Nt}from"react/jsx-runtime";var gg=fs(({header:e,description:o,calloutTheme:t="warning",icon:r=ys,...n},a)=>{let i=be(),s=gs(()=>({warning:{color:i.colors.yellow11,borderColor:$(i.colors.yellow11,.32),backgroundColor:$(i.colors.yellow11,.08)},danger:{color:i.colors.red11,borderColor:$(i.colors.red11,.32),backgroundColor:$(i.colors.red11,.08)},success:{color:i.colors.green11,borderColor:$(i.colors.green11,.32),backgroundColor:$(i.colors.green11,.08)},info:{color:i.colors.violet11,borderColor:$(i.colors.violet11,.32),backgroundColor:$(i.colors.violet11,.08)}}),[i]),{color:l,borderColor:p,backgroundColor:c}=s[t];return Nt(xs,{...n,ref:a,style:{color:l,backgroundColor:c,boxShadow:`inset 0 0 0 1px ${p}`,...n.style},children:[So(y,{icon:r,size:"xs"}),Nt(bs,{children:[So(m,{color:l,tag:"h6",variant:"headingSm",children:e}),So(m,{color:l,tag:"p",variant:"textSm",children:o})]})]})});var xs=Vt.div`
  ${({theme:e})=>us`
    display: flex;
    flex-direction: row;
    gap: 12px;
    align-items: center;
    justify-content: flex-start;
    padding: ${e.spacing.s3};
    border-radius: 8px;
    width: 100%;
    box-sizing: border-box;
  `}
`,bs=Vt.div``;import{createContext as hs,forwardRef as Ps,useCallback as Ht,useMemo as Ts,useReducer as Is,useState as Cs}from"react";import Ge,{css as Wt}from"styled-components";import{faAngleLeft as Ss}from"@fortawesome/pro-regular-svg-icons";import{jsx as wo}from"react/jsx-runtime";var $o=hs({onActiveRouteChange:()=>{},toggleSubMenuAtKey:()=>{},isExpandedAtKey:()=>!1}),ws=({children:e,defaultRoute:o,route:t,onRouteSelected:r})=>{let[n,a]=Cs(o),[i,s]=Is((c,d)=>({...c,[d]:!(c[d]??!1)}),{}),l=Ht(c=>i[c]??!1,[i]),p=Ht(c=>{r==null||r(c),t==null&&a(c)},[t,r]);return wo($o.Provider,{value:Ts(()=>({activeRoute:t??n,onActiveRouteChange:p,toggleSubMenuAtKey:s,isExpandedAtKey:l}),[t,n,l,p]),children:e})},Gt=Ps(({width:e="240px",route:o,defaultRoute:t,onRouteSelected:r,...n},a)=>wo(ws,{route:o,defaultRoute:t,onRouteSelected:r,children:wo($s,{...n,ref:a,style:{width:e,...n.style}})})),$s=Ge.nav`
  ${({theme:e})=>{var o,t;return Wt`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    padding: 20px 12px;
    gap: 10px;
    height: 100%;
    background-color: ${(o=e.colors)==null?void 0:o.gray1};
    border-right: 1px solid ${(t=e.colors)==null?void 0:t.gray6};
  `}}
`,Xt=Ge.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 4px;
  width: 100%;
`,_t=Ge(B).attrs({icon:Ss,buttonTheme:"secondary",variant:"inline",text:"Back"})`
  && {
    height: 36px;
    padding: 0px 12px;
  }
`,Ut=Ge.hr`
  ${({theme:e})=>{var o;return Wt`
      all: unset;
      display: flex;
      height: 1px;
      width: 100%;
      background-color: ${(o=e.colors)==null?void 0:o.gray6};
      margin: 6px 0;
    `}}
`;import{useContext as Rs,useEffect as ks,useState as Ms}from"react";import{faAngleDown as Ds}from"@fortawesome/pro-solid-svg-icons";import ce,{css as le}from"styled-components";var vs={normal:"8px 12px",small:"6px 12px"},jt=le`
  ${({theme:e,$selected:o,$size:t})=>le`
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      border-radius: 8px;
      user-select: none;
      cursor: pointer;

      padding: ${vs[t]};
      color: ${e.colors.gray11};

      &:hover {
        background-color: ${e.colors.gray4};
        box-shadow: inset 0 0 0 1px ${e.colors.gray8};
        color: ${e.colors.gray12};
      }
      &:active {
        background-color: ${e.colors.gray5};
        box-shadow: inset 0 0 0 1px ${e.colors.gray8};
        color: ${e.colors.gray12};
      }

      ${o&&le`
        background-color: ${e.colors.gray3};
        box-shadow: inset 0 0 0 1px ${e.colors.gray7};
        color: ${e.colors.gray12};
      `}
    `}
`,Zt=ce.a`
  ${jt}
  text-decoration: none;
`,vo=ce.div`
  ${jt}
`,Yt=ce.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  color: inherit;
  flex-grow: 1;
`,Kt=ce(y)`
  ${({$open:e})=>le`
    transition: transform 0.2s linear;
    ${e?le`
          transform: rotate(180deg);
        `:void 0}
  `}
`,Jt=ce.div`
  display: flex;
  padding: 0px 0px 0px calc(12px + 7.5px);
  gap: 4px;
  width: 100%;
`,qt=ce.div`
  ${({theme:e})=>le`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 4px;
    padding: 0px 0px 0px 6.5px;
    box-shadow: -1px 0px 0px 0px ${e.colors.gray6};
  `}
`;import{Fragment as Bs,jsx as G,jsxs as Ro}from"react/jsx-runtime";var Qt=({label:e,route:o,icon:t,options:r,initialExpanded:n=!1,size:a,...i})=>{let{activeRoute:s,onActiveRouteChange:l}=Rs($o),[p,c]=Ms(n);ks(()=>{c(f=>(r==null?void 0:r.some(g=>g.route===s))||f)},[s,r]);let d=()=>Ro(Yt,{children:[t?G(y,{color:"gray11",icon:t,size:"xs"}):null,G(m,{tag:"label",variant:"textSmPlus",children:e})]});return o?G(Zt,{$selected:s===o,$size:a,href:o,onClick:f=>{var g;f.preventDefault(),l(o),(g=i.onClick)==null||g.call(i,f)},...i,children:d()}):r?Ro(Bs,{children:[Ro(vo,{$size:a,onClick:()=>c(f=>!f),children:[d(),G(Kt,{$open:p,color:"gray11",icon:Ds,size:"xs"})]}),p&&r.length>0?G(Jt,{children:G(qt,{children:r.map(({size:f,...g},P)=>G(Qt,{...g,size:"small"},P))})}):void 0]}):G(vo,{$size:a,...i,children:d()})},er=e=>G(Qt,{...e,size:"normal"});var Og={Nav:Gt,Group:Xt,Item:er,Back:_t,Divider:Ut};import{useEffect as Hs,useRef as Ws,useState as Gs}from"react";import Do,{css as tr}from"styled-components";import Xs from"typewriter-effect";import _s from"highlight.js";import"highlight.js/styles/base16/tomorrow-night.css";import{faClipboard as Us}from"@fortawesome/pro-regular-svg-icons";import{forwardRef as Fs,useEffect as zs,useRef as Es,useState as Os}from"react";import{faCheck as Ls,faCopy as As}from"@fortawesome/pro-regular-svg-icons";import Ns from"styled-components";import{jsx as ko}from"react/jsx-runtime";var or=Fs(({className:e,text:o,icon:t=As,...r},n)=>{let a=Es(null),[i,s]=Os(!1);return zs(()=>{let p=a.current;return()=>{p&&clearTimeout(p)}},[]),ko(Vs,{className:e,children:i?ko(y,{color:"green11",icon:Ls,size:"xs"}):ko(F,{buttonTheme:"secondary",variant:"inline",icon:t,size:"xs",...r,onClick:(p=>async()=>{await navigator.clipboard.writeText(p),s(!0),a.current=setTimeout(()=>{s(!1)},2500)})(o),ref:n})})});var Vs=Ns.div`
  display: inline-flex;
  white-space: nowrap;
  flex-shrink: 0;
  flex-direction: row;
  justify-content: center;
  width: fit-content;
  height: fit-content;
  align-items: center;
  box-sizing: border-box;
  overflow: hidden;
`;import{jsx as Mo,jsxs as Ks}from"react/jsx-runtime";var rr=({className:e,language:o,content:t,enableCopy:r=!0,fontVariant:n="monoXs",typeWriterEffect:a=!1})=>{let i=Ws(null),[s,l]=Gs("");return Hs(()=>{if(t&&t.length>0){let p=document.createElement("code");p.classList.add(o),p.classList.add("hljs"),p.textContent=o.includes("shell")?`$ ${t.trim()}`:t.trim(),_s.highlightElement(p),a?l(p.innerHTML):i.current&&(i.current.innerHTML="",i.current.appendChild(p))}},[t,o,a]),Ks(js,{className:e,children:[Mo(Ys,{$fontVariant:n,ref:i,children:a?Mo(Xs,{onInit:p=>{p.typeString(s).start()},options:{delay:.3,autoStart:!0,wrapperClassName:`Typewriter__wrapper hljs ${o}`}}):null}),r&&t?Mo(Zs,{icon:Us,text:t}):null]})};var js=Do.div`
  ${({theme:e})=>tr`
      position: relative;
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      padding: 12px 16px;
      box-sizing: border-box;
      isolation: isolate;
      width: 100%;
      min-height: 46px;
      background-color: ${e.colors.gray2};
      border: 1px solid ${e.colors.gray6};
      border-radius: 8px;
      gap: 8px;
    `}
`,Zs=Do(or)`
  && {
    margin-top: 3.5px;
    flex-shrink: 0;
    white-space: nowrap;
  }
`,Ys=Do.pre`
  && {
    ${({theme:e,$fontVariant:o="monoXs"})=>tr`
        position: relative;
        width: 100%;
        box-sizing: border-box;
        padding: 0;
        margin: 0;
        background-color: inherit;
        overflow: auto;

        .hljs {
          display: inline;
          background: transparent;
          padding: 0;
          ${e.styleSet[o]};
        }

        .Typewriter__cursor {
          display: inline;
          color: #d9d9d9;
        }
      `}
  }
`;import{forwardRef as Js}from"react";import Ie,{css as _e}from"styled-components";import{faMultiply as qs}from"@fortawesome/pro-regular-svg-icons";import{jsx as de,jsxs as Xe}from"react/jsx-runtime";var iu=Js(({content:e,enableCopy:o,tabs:t=[],activeTab:r,language:n="language-python",typeWriterEffect:a=!1,...i},s)=>Xe(Qs,{...i,ref:s,children:[Xe(ep,{children:[Xe(Bo,{children:[de(Fo,{}),de(Fo,{}),de(Fo,{})]}),t.map(l=>Xe(Bo,{$active:r===l,children:[l,de(y,{color:"gray11",icon:qs,size:"xs"})]},l)),de(Bo,{})]}),de(op,{content:e,enableCopy:o,fontVariant:"monoSm",language:n,typeWriterEffect:a})]}));var Qs=Ie.div`
  ${({theme:e})=>_e`
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 0px;
      box-sizing: border-box;
      background-color: ${e.colors.gray2};
      border: 1px solid ${e.colors.gray8};
      border-radius: 8px;
      overflow: hidden;
    `}
`,ep=Ie.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  width: 100%;
  height: 48px;
`,Bo=Ie.div`
  ${({theme:e,$active:o})=>_e`
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 12px 16px;
      gap: 6px;
      height: 100%;
      color: ${e.colors.gray12};
      border-right: 1px solid ${e.colors.gray8};
      border-bottom: ${o?void 0:`1px solid ${e.colors.gray8}`};
      ${e.styleSet.monoSm};

      &:last-of-type {
        width: 100%;
        flex-grow: 1;
        border-right: none;
      }
    `}
`,Fo=Ie.div`
  ${({theme:e})=>_e`
      flex-shrink: 0;
      white-space: nowrap;
      width: 9px;
      height: 9px;
      border-radius: 50%;
      background-color: ${e.colors.gray10};
    `}
`,op=Ie(rr)`
  && {
    ${({theme:e})=>_e`
        padding: 16px;
        border: none;
        border-radius: 0;
        background: transparent;
        ${e.styleSet.monoSm};
      `}
  }
`;import{useState as tp}from"react";import rp from"styled-components";import{faAngleLeft as np,faAngleRight as ip}from"@fortawesome/pro-regular-svg-icons";import{Fragment as sp,jsx as zo,jsxs as Eo}from"react/jsx-runtime";var fu=({defaultPage:e,page:o,count:t,hasPrev:r=!1,hasNext:n=!1,getPrevPage:a,getNextPage:i})=>{let[s,l]=tp(o??e??1),p=()=>{l(f=>Math.max(1,f-1)),a&&a()},c=()=>{l(f=>t?Math.min(t,f+1):f+1),i&&i()},d=r||s>1,u=n||t&&s<t;return Eo(ap,{children:[zo(F,{buttonTheme:"secondary",disabled:!d,icon:np,onClick:p,variant:"ghost"}),Eo(m,{color:"gray11",tag:"span",variant:"textSmPlus",children:[zo(m,{color:"gray12",tag:"span",variant:"textSmPlus",children:s}),t!=null&&Eo(sp,{children:[" / ",t??1]})]}),zo(F,{buttonTheme:"secondary",disabled:!u,icon:ip,onClick:c,variant:"ghost"})]})};var ap=rp.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 16px;
  margin: 0 auto;
`;import{Children as nr,cloneElement as pp,isValidElement as lp}from"react";import me,{css as ar}from"styled-components";import{jsx as Ue,jsxs as ir}from"react/jsx-runtime";var bu=({children:e,...o})=>{let t=nr.toArray(e);return Ue(fp,{...o,children:nr.map(t,(r,n)=>{if(!lp(r))return null;let a=n===t.length-1;return ir(sr,{children:[ir(cp,{children:[Ue(dp,{children:n+1}),!a&&Ue(mp,{})]}),Ue(pr,{children:pp(r)})]})})})};var sr=me.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 16px;
  width: 100%;
`,cp=me.div`
  display: grid;
  grid-template-rows: auto 1fr;
  justify-items: center;
  grid-gap: 8px;
`,dp=me.label`
  ${({theme:e})=>ar`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px;
    color: ${e.colors.gray12};
    flex-shrink: 0;

    ${e.styleSet.headingXs};
    line-height: 16px;

    width: 28px;
    height: 28px;
    background-color: ${e.colors.gray3};
    border: 1px solid ${e.colors.gray6};
    border-radius: 8px;
  `}
`,mp=me.div`
  ${({theme:e})=>ar`
    width: 1px;
    background-color: ${e.colors.gray6};
  `}
`,pr=me.div`
  position: relative;
  display: flex;
  box-sizing: border-box;
  padding: 4px 0px 0px;
  margin-bottom: 24px;
  width: 100%;
  min-width: 0;
`,fp=me.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  width: 100%;

  ${sr}:last-child > ${pr} {
    margin-bottom: 0;
  }
`;import cr from"styled-components";import{Fragment as yp,jsx as je,jsxs as lr}from"react/jsx-runtime";var Cu=({title:e,descriptions:o,children:t,...r})=>lr(gp,{...r,children:[lr(up,{children:[je(m,{color:"gray12",tag:"h4",variant:"headingSm",children:e}),Array.isArray(o)?je(yp,{children:o.map((a,i)=>je(m,{color:"gray11",tag:"p",variant:"textSm",children:a},i))}):typeof o=="function"?o():je(m,{color:"gray11",tag:"p",variant:"textSm",children:o})]}),t]});var gp=cr.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  gap: 12px 48px;
`,up=cr.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 6px;
`;import{forwardRef as xp}from"react";import Oo,{css as bp}from"styled-components";import{faTimes as hp}from"@fortawesome/pro-regular-svg-icons";import{jsx as dr,jsxs as Ze}from"react/jsx-runtime";var Du=xp(({id:e,name:o,label:t,message:r,ctaButtonConfig:n,onDismiss:a,...i},s)=>Ze(Pp,{...i,ref:s,children:[Ze(Tp,{children:[Ze(m,{color:"gray12",tag:"p",variant:"textSm",children:[t?Ze(m,{tag:"span",variant:"textSmPlus",children:[t," "]}):null,r]}),n!=null&&n.text?dr(B,{buttonTheme:"info",height:28,onClick:n.onClick,children:n.text}):null]}),dr(Ip,{buttonTheme:"secondary",icon:hp,onClick:()=>a==null?void 0:a(e,o),variant:"inline"})]}));var Pp=Oo.div`
  ${({theme:e})=>bp`
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 6px 24px;
      gap: 12px;
      isolation: isolate;
      width: 100%;
      background-color: ${e.colors.violet8};
    `}
`,Tp=Oo.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 12px;
  flex: 1;
`,Ip=Oo(F)`
  color: ${({theme:e})=>e.colors.gray12};
`;import{useState as Ke,useEffect as vp,useRef as yr}from"react";import J,{css as Ye}from"styled-components";import{Root as Cp,List as Sp,Trigger as wp,Content as $p}from"@radix-ui/react-tabs";var mr=J(Cp)`
  ${({$gap:e=16,orientation:o="horizontal"})=>Ye`
      display: flex;
      align-items: flex-start;
      padding: 0;
      gap: ${e}px;
      width: 100%;
      max-height: 100%;
      flex-direction: ${o==="horizontal"?"column":"row"};

      ${Lo} {
        flex-direction: ${o==="horizontal"?"row":"column"};
      }
    `}
`,Lo=J(Sp)`
  ${({$px:e=0,$currentTabX:o})=>Ye`
      position: relative;
      display: flex;
      align-items: flex-start;
      padding: 0 ${e}px;
      gap: 8px;
      z-index: 0;
      width: 100%;

      ${Ao} {
        transform-origin: ${e}px 0;
        transform: translateX(${o}px);
      }
    `}
`,Au=J(re)`
  && {
    margin-left: auto;
    margin-right: 0;
  }
`,fr=J(vt)`
  && {
    margin-left: auto;
    margin-right: 0;
  }
`,gr=J(wp)`
  ${({theme:e})=>Ye`
      all: unset;
      position: relative;
      z-index: 2;
      display: inline-block;
      ${e.styleSet.textSmPlus};
      white-space: nowrap;
      min-width: fit-content;
      width: fit-content;
      box-sizing: border-box;
      box-shadow: ${e.shadows.base};
      border-radius: 6px;
      overflow: hidden;
      cursor: pointer;

      height: 36px;
      padding: 0px 12px;
      background-color: transparent;
      color: ${e.colors.gray11};

      &:hover,
      &:active,
      &[data-state="active"] {
        color: ${e.colors.gray12};
      }
    `}
`,Ao=J.span`
  ${({theme:e,$width:o})=>Ye`
      position: absolute;
      height: 36px;
      width: ${o}px;
      padding: 0px 11px;
      box-sizing: border-box;
      border-radius: 6px;
      z-index: 1;
      background-color: ${e.colors.gray3};
      box-shadow:
        ${e.shadows.base},
        inset 0 0 0 1px ${e.colors.gray7};
      transition: transform 100ms linear;
    `}
`,ur=J($p)`
  width: 100%;
  height: 100%;
  overflow-y: scroll;
`;import{Fragment as Rp,jsx as Ce,jsxs as xr}from"react/jsx-runtime";var Wu=({className:e,tabs:o,px:t=0,gap:r=16,orientation:n="horizontal"})=>{let a=yr(null),i=yr([]),[s,l]=Ke(0),[p,c]=Ke(0),[d,u]=Ke(0),[f,g]=Ke(0);vp(()=>{let x=o[s],b=i.current[s],w=a.current;if(w&&b&&x){let R=b.getBoundingClientRect(),h=w.getBoundingClientRect();g(R.left-h.left-t),u(R.width)}},[o,t,s]);let P=x=>{c(0),l(parseInt(x))},T=o.map(({name:x,contents:b},w)=>{let R=x,h=b;if(Array.isArray(b)){let I=w===s?p:0;R=b.length>0?`${x}-${b[I].type}`:void 0,h=b.length>0?b[I].component:void 0}if(R)return{value:w,label:x,component:h}}).filter(x=>x!==void 0),v=Array.isArray(o[s].contents)?o[s].contents.map(({type:x,component:b,...w},R)=>({value:R,label:x,...w})):void 0;return Ce(mr,{$gap:r,className:e,onValueChange:P,orientation:n,value:s.toString(),children:T.length>0&&xr(Rp,{children:[xr(Lo,{$currentTabX:f,$px:t,ref:a,children:[T.map(({value:x,label:b},w)=>Ce(gr,{asChild:!1,ref:R=>R&&(i.current[w]=R),value:x.toString(),children:b},w)),d>0&&Ce(Ao,{$width:d}),v?Ce(fr,{align:"end",hideWhenDetached:!0,onChange:x=>{c(parseInt(x))},options:v,value:Math.max(0,Math.min(v.length-1,p))}):null]}),T.map(({value:x,component:b},w)=>Ce(ur,{value:x.toString(),children:typeof b=="function"?b():b},w))]})})};import{css as br}from"styled-components";import"react-toastify/dist/ReactToastify.css";import{faCircleInfo as kp}from"@fortawesome/pro-solid-svg-icons";import{jsx as Mp}from"react/jsx-runtime";var Yu={limit:2,closeButton:!0,closeOnClick:!1,hideProgressBar:!0,pauseOnHover:!1,pauseOnFocusLoss:!1,position:"top-center",icon:Mp(y,{color:"gray12",icon:kp,size:"sm"}),className:"beam-ToastProvider",toastClassName:"beam-Toast",bodyClassName:"beam-ToastBody",progressClassName:"beam-ToastProgress"},Ku=br`
  ${({theme:e})=>br`
    /* .beam-ToastProvider */
    width: max-content !important;

    --toastify-color-light: ${e.colors.gray12};
    --toastify-color-dark: ${e.colors.gray1};
    --toastify-color-info: ${e.colors.blue11};
    --toastify-color-success: ${e.colors.green11};
    --toastify-color-warning: ${e.colors.yellow11};
    --toastify-color-error: ${e.colors.red11};
    --toastify-color-transparent: rgba(255, 255, 255, 0.7);

    --toastify-icon-color-info: ${e.colors.gray12} !important;
    --toastify-icon-color-error: ${e.colors.gray12} !important;
    --toastify-icon-color-warning: ${e.colors.gray12} !important;
    --toastify-icon-color-success: ${e.colors.gray12} !important;
    --toastify-icon-color-error: ${e.colors.gray12} !important;

    .Toastify__toast--warning {
      background-color: ${e.colors.yellow9};
    }

    .Toastify__toast--success {
      background-color: ${e.colors.green9};
    }

    .Toastify__toast--info {
      background-color: ${e.colors.blue9};
    }

    .Toastify__toast--default {
      background-color: ${e.colors.blue9};
    }

    .Toastify__toast--error {
      background-color: ${e.colors.red9};
    }

    .Toastify__close-button > svg {
      fill: ${e.colors.white} !important;
    }

    .Toastify__close-button--light {
      opacity: 0.9;
    }

    /* .beam-Toast is passed to toastClassName */
    .beam-Toast {
      border-radius: 8px;
      min-height: 46px;
      min-width: 400px;
    }

    button[aria-label="close"] {
      display: flex;
      align-items: center;
      margin: auto;
      margin-right: 6px;
    }

    /* .beam-ToastBody is passed to bodyClassName */
    .beam-ToastBody {
      color: ${e.colors.white};
      ${e.styleSet.textSm};
      text-align: center;
    }

    /* .beam-ToastProgress is passed to progressClassName */
    .beam-ToastProgress {
      background: white;
      --toastify-color-progress-light: ${e.colors.white};
      width: 100%;
      height: 2px;
    }

    .progress-infinite-loading {
      background: white;
      --toastify-color-progress-light: ${e.colors.white};
      width: 50%;
      height: 2px;

      animation-duration: 1.5s !important;
      animation-name: infinite-progress-bar !important;
      animation-direction: reverse;
      animation-iteration-count: infinite;

      @keyframes infinite-progress-bar {
        0% {
          transform: translateX(200%);
        }
        100% {
          transform: translateX(-100%);
        }
      }
    }
  `}
`;import{Children as hr,cloneElement as Pr,forwardRef as Dp,isValidElement as Bp}from"react";import qe,{css as Je}from"styled-components";import{faAngleRight as Fp}from"@fortawesome/pro-regular-svg-icons";import{jsx as fe,jsxs as Lp}from"react/jsx-runtime";var ny=({href:e,...o})=>e?fe(Ir,{tag:"a",...o,color:"gray12",href:e}):fe(Ir,{...o,color:"gray12"}),iy=Dp(({size:e="small",children:o,...t},r)=>{let n=hr.toArray(o);return fe(zp,{$size:e,...t,ref:r,children:hr.map(n,(a,i)=>Bp(a)?i===n.length-1?fe(Tr,{children:Pr(a)}):Lp(Tr,{children:[Pr(a),fe(Op,{color:"gray11",tag:"span",children:fe(y,{color:"gray11",icon:Fp,size:"sm"})})]}):null)})});var zp=qe.div`
  ${({theme:e,$size:o})=>Je`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 0px;
    white-space: nowrap;
    overflow: hidden;
    width: fit-content;
    ${o==="small"?e.styleSet.headingSm:e.styleSet.headingLg}
    * {
      font: inherit;
    }
  `}
`,Tr=qe.div`
  display: flex;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 8px;

  &:first-child {
    flex: 0 0 auto;
    padding-left: 0;
  }

  flex: 0 1000 auto;

  &:last-child {
    flex: 0 0 auto;
  }

  &:hover {
    flex: 1 0 auto;
  }
`,Ep=Je`
  ${({href:e,onClick:o})=>Je`
    font: inherit;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    ${e||o?Je`
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        `:null}
  `}
`,Ir=qe(m)`
  ${Ep}
`,Op=qe(m)`
  margin-left: 8px;
  display: flex;
  align-items: center;
`;import Vo from"styled-components";import{jsx as No,jsxs as Hp}from"react/jsx-runtime";var Cr=({payload:e})=>No(Ap,{children:e==null?void 0:e.map(({color:o,value:t},r)=>Hp(Np,{children:[No(Vp,{color:o}),No(m,{color:"gray11",variant:"textXs",children:t})]},`item-${r}`))});var Ap=Vo.ul`
  display: flex;
  justify-content: center;
  gap: 16px;
  list-style: none;
  margin: 0;
  margin-top: 16px;
`,Np=Vo.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`,Vp=Vo.div`
  background-color: ${e=>e.color};
  border-radius: 4px;
  width: 16px;
  height: 16px;
`;import ge,{css as Sr}from"styled-components";import{jsx as S,jsxs as X}from"react/jsx-runtime";var wr=({renderer:e,...o})=>{let{active:t=!0,label:r,payload:n,sortCompareFn:a,displayLabelFn:i,displayPayloadFn:s}=o;if(!t||!(n!=null&&n.length))return null;let l=a?n.sort(a):n;return e?e(o):X($r,{children:[S(m,{color:"gray11",tag:"span",variant:"textSmPlus",children:(i==null?void 0:i(r))??r}),S(vr,{children:S("tbody",{children:l.map((p,c)=>X("tr",{children:[S("td",{children:X(Ho,{children:[S(Rr,{$color:p.color}),S(m,{color:"gray12",tag:"span",variant:"textSmPlus",children:p.name||p.dataKey})]})}),S("td",{children:S(Wo,{children:(s==null?void 0:s(p.value,p.unit))||p.value})})]},c))})})]})},gy=({renderer:e,...o})=>{let{active:t=!0,label:r,payload:n,sortCompareFn:a,displayLabelFn:i,displayPayloadFn:s}=o;if(!t||!(n!=null&&n.length))return null;let l=Wp(n);if(!l)return null;let p=a?n.sort(a):n;return e?e(o):X($r,{children:[S(m,{color:"gray11",tag:"span",variant:"textSmPlus",children:(i==null?void 0:i(r))??r}),S(Gp,{children:X("tbody",{children:[p.map((c,d)=>{var u;return X("tr",{children:[S("td",{children:X(Ho,{children:[S(Rr,{$color:c.color}),S("span",{children:c.name||c.dataKey})]})}),S("td",{children:S(Wo,{children:(s==null?void 0:s(c.value,c.unit))||((u=c.value)==null?void 0:u.toFixed(2))})})]},d)}),X("tr",{children:[S("td",{children:S(Ho,{children:"Total"})}),S("td",{children:S(Wo,{children:(s==null?void 0:s(l,p[0].unit))||l.toFixed(2)})})]})]})})]})};var Wp=e=>{let o=0;return e.forEach(t=>o+=t.value??0),o},$r=ge.div`
  ${({theme:e})=>Sr`
      display: flex;
      /* max-width: 240px; */
      padding: 8px 12px;
      flex-direction: column;
      align-items: flex-start;
      gap: 6px;
      border-radius: 10px;
      background-color: ${e.colors.gray4};
      border: 1px solid ${e.colors.gray7};
      box-shadow: ${e.shadows.sm};
    `}
`,vr=ge.table`
  border-collapse: collapse;

  td:first-of-type {
    padding-right: 12px;
  }

  tr:last-of-type td:first-of-type {
    float: right;
  }
`,Gp=ge(vr)``,Ho=ge(m).attrs({color:"gray12",tag:"span",variant:"textSmPlus"})`
  display: flex;
  align-items: center;
  gap: 8px;
`,Wo=ge(m).attrs({color:"gray11",tag:"span",variant:"textSm"})``,Rr=ge.span`
  ${({theme:e,$color:o})=>Sr`
    background-color: ${o??e.colors.gray11};
    width: 6px;
    height: 6px;
    border-radius: 50%;
  `}
`;import{Fragment as Xp}from"react";import*as C from"recharts";import _p,{css as Up,useTheme as jp}from"styled-components";import{jsx as z,jsxs as Go}from"react/jsx-runtime";var Zp=({className:e,variant:o,isAnimationActive:t=!1,width:r="100%",height:n="100%",type:a,config:i,children:s,...l})=>{let p=jp(),c=p.typography.styleSet.text.textXs,{grid:d=!1,xAxis:u,yAxis:f,tooltip:g,legend:P=!1}=i??{},T=Se(d),v=Se(u),x=Se(f),b=Se(g),w=Se(P),R=o??(a==="area"?"gradient":"solid"),h=a==="area"?{cursor:{stroke:p.colors.gray9},wrapperStyle:{outline:"none"}}:{cursor:{fill:p.colors.gray7},wrapperStyle:{outline:"none"}},I=a==="area"?i==null?void 0:i.areas:a==="bar"?i==null?void 0:i.bars:[],V=a==="area"?C.AreaChart:a==="bar"?C.BarChart:void 0;return!V||!Zp?null:z(Yp,{$height:n,$width:r,children:z(C.ResponsiveContainer,{className:e,height:"100%",width:"100%",children:Go(V,{...l,children:[T?z(C.CartesianGrid,{stroke:p.colors.gray5,strokeDasharray:"3 3",...T}):null,v?z(C.XAxis,{domain:["dataMin","dataMax"],orientation:"bottom",stroke:p.colors.gray11,...v,style:{...c,...v.style}}):null,x?z(C.YAxis,{orientation:"left",stroke:p.colors.gray11,...x,style:{...c,...x.style}}):null,b?z(C.Tooltip,{content:z(wr,{...b}),...h}):null,w?z(C.Legend,{content:z(Cr,{...w})}):null,(I??[]).map(({ref:U,fill:j="blue9",...Re},M)=>{let q=`linear-gradient-${M}`,Z=p.colors[j]??j,ye={type:"monotone",...Re,fill:R==="gradient"?`url(#${q})`:Z,isAnimationActive:t,stackId:"a",stroke:Z};return Go(Xp,{children:[R==="gradient"&&z("defs",{children:Go("linearGradient",{id:q,x1:"0",x2:"0",y1:"0",y2:"1",children:[z("stop",{stopColor:Z,stopOpacity:.32}),z("stop",{offset:"1",stopColor:Z,stopOpacity:0})]})}),a==="area"?z(C.Area,{activeDot:{fill:"white",stroke:"white",r:3},...ye}):z(C.Bar,{...ye})]},M)}),s]})})})};var Se=e=>typeof e=="boolean"?e&&{}:e??{},Yp=_p.div`
  ${({$width:e,$height:o})=>Up`
    width: ${e};
    height: ${o};
  `}
`;import{forwardRef as _r,useState as jl}from"react";import so,{css as Uo}from"styled-components";import{Root as Zl,Trigger as Yl}from"@radix-ui/react-popover";import{useDateRangePickerState as Kl}from"react-stately";import{useDateRangePicker as Jl}from"react-aria";import{parseAbsoluteToLocal as Xr}from"@internationalized/date";import{faCalendar as ql,faTimes as Ql}from"@fortawesome/pro-regular-svg-icons";import{format as ao,isSameDay as ec}from"date-fns";import oc from"classnames";import{forwardRef as Kp}from"react";import{Portal as Jp,Content as qp}from"@radix-ui/react-popover";import Qp,{css as el}from"styled-components";import{jsx as kr}from"react/jsx-runtime";var Qe=Kp(({container:e,minWidth:o,...t},r)=>kr(Jp,{container:e,children:kr(ol,{$minWidth:o,ref:r,...t})})),ol=Qp(qp)`
  ${({theme:e,$minWidth:o})=>el`
    display: flex;
    padding: 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;

    min-width: ${o};

    border-radius: 8px;
    border: 1px solid ${e.colors.gray6};
    background: ${e.colors.gray2};

    box-shadow: ${e.shadows.sm};
  `}
`;import{useRef as tl,useEffect as rl}from"react";var E=(e,o=null)=>{let t=tl(o);return rl(()=>{e&&(typeof e=="function"?e(t.current):e.current=t.current)},[e]),t};import{forwardRef as Dr}from"react";import{useDateField as cl,useLocale as dl}from"react-aria";import{useDateFieldState as ml}from"react-stately";import{createCalendar as fl}from"@internationalized/date";import Br,{css as Fr}from"styled-components";import{Slot as gl}from"@radix-ui/react-slot";import{forwardRef as nl}from"react";import{useDateSegment as il}from"react-aria";import al,{css as Mr}from"styled-components";import{jsx as ll}from"react/jsx-runtime";var sl=nl(({segment:e,state:o},t)=>{let r=E(t),{segmentProps:n}=il(e,o,r);return ll(pl,{$isEditable:e.isEditable,$isPlaceholder:e.isPlaceholder,...n,ref:r,style:{...n.style},children:e.text??e.placeholder})}),eo=sl,pl=al.div`
  ${({theme:e,$isEditable:o})=>Mr`
    text-align: end;
    padding: 2px 4px;
    box-sizing: content-box;
    border-radius: 4px;
    outline: 2px solid transparent;
    outline-offset: 2px;

    &:focus {
      color: ${e.colors.gray12};
      background-color: ${e.colors.blue9};
    }

    ${!o&&Mr`
      color: ${e.colors.gray11};
      background-color: initial;
      padding: initial;
    `}
  `}
`;import{jsx as we}from"react/jsx-runtime";var oo=Dr(({className:e,...o},t)=>{let r=E(t),{locale:n}=dl(),a=ml({...o,locale:n,createCalendar:fl}),{fieldProps:i}=cl({...o,"aria-label":"Date Input","aria-labelledby":"beam-DateInput"},a,r);return we(to,{children:we("div",{...i,"aria-label":`date-field-${i.id}`,"aria-labelledby":`date-field-${i.id}`,className:e,ref:r,children:a.segments.reduce((s,l,p)=>l.type!=="timeZoneName"?[...s,we(eo,{segment:l,state:a},p)]:s,[])})})}),ul=Dr(({width:e,...o},t)=>we(Xo,{$width:e,children:we(oo,{...o,ref:t})}));var to=Br(gl)`
  ${({theme:e})=>Fr`
      position: relative;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      overflow: hidden;
      background-color: transparent;
      color: ${e.colors.gray12};
      outline: none;
      border: none;
      ${e.styleSet.textSm};

      &[aria-disabled] {
        color: ${e.colors.gray11};
      }
    `}
`,Xo=Br(to)`
  ${({theme:e,$width:o})=>Fr`
      width: ${o};
      height: 36px;
      overflow: hidden;
      padding: 8px 12px;
      background-color: ${e.colors.gray3};
      box-shadow: inset 0 0 0 1px ${e.colors.gray7};
      border-radius: 8px;
      color: ${e.colors.gray12};

      &:hover {
        background-color: ${e.colors.gray4};
        box-shadow: inset 0 0 0 1px ${e.colors.gray8};
      }

      &[aria-disabled] {
        color: ${e.colors.gray11};
      }

      &:focus-within {
        background-color: ${e.colors.gray4};
        box-shadow:
          inset 0 0 0 1px ${e.colors.blue9},
          0px 0px 0px 2px ${e.colors.blue7};
      }
    `}
`;import{forwardRef as zl}from"react";import{useLocale as El,useRangeCalendar as Ol}from"react-aria";import{useRangeCalendarState as Ll}from"react-stately";import{createCalendar as Al}from"@internationalized/date";import Hr from"styled-components";import{faChevronLeft as Nl,faChevronRight as Vl}from"@fortawesome/pro-regular-svg-icons";import{forwardRef as Cl}from"react";import{useCalendarGrid as Sl,useLocale as wl}from"react-aria";import{endOfMonth as $l,getWeeksInMonth as vl}from"@internationalized/date";import Ar from"styled-components";import{forwardRef as yl}from"react";import{useCalendarCell as xl,useLocale as bl}from"react-aria";import{getDayOfWeek as hl,isSameDay as zr,isSameMonth as Pl}from"@internationalized/date";import Or,{css as ro}from"styled-components";import{jsx as Er}from"react/jsx-runtime";var Lr=yl(({className:e,state:o,currentMonth:t,...r},n)=>{let a=E(n),{cellProps:i,buttonProps:s,isSelected:l,isInvalid:p,formattedDate:c}=xl(r,o,a),{date:d}=r,{locale:u}=bl(),f=hl(d,u),g=t?!Pl(t,d):void 0,P=o.highlightedRange?zr(d,o.highlightedRange.start):l,T=o.highlightedRange?zr(d,o.highlightedRange.end):l,v=l&&(P||f===0||d.day===1),x=l&&(T||f===6||d.day===d.calendar.getDaysInMonth(d));return Er(Tl,{...i,className:e,children:Er(Il,{...s,$isRoundedLeft:v,$isRoundedRight:x,$isSelected:l,buttonTheme:p?"danger":l?"primary":"secondary",disabled:g,ref:a,size:"sm",variant:l?"solid":"ghost",width:"100%",children:c})})});var Tl=Or.td``,Il=Or(B)`
  ${({$isSelected:e,$isRoundedLeft:o,$isRoundedRight:t})=>ro`
    aspect-ratio: 1/1;
    border-radius: 0px;

    ${!e&&ro`
      &:hover {
        border-radius: 8px;
      }
    `}

    && {
      ${o&&ro`
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
      `};
      ${t&&ro`
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
      `}
    }
  `}
`;import{jsx as _,jsxs as Ml}from"react/jsx-runtime";var Nr=Cl(({className:e,state:o,offset:t={},...r},n)=>{let{locale:a}=wl(),i=o.visibleRange.start.add(t),s=$l(i),{gridProps:l,headerProps:p,weekDays:c}=Sl({...r,startDate:i,endDate:s},o),d=vl(o.visibleRange.start,a);return Ml(Rl,{...l,cellPadding:"0",className:e,ref:n,children:[_("thead",{...p,children:_("tr",{children:c.map((u,f)=>_(kl,{children:_(m,{color:"gray12",tag:"span",variant:"textSmPlus",children:u})},f))})}),_("tbody",{children:[...Array(d)].map((u,f)=>_("tr",{children:o.getDatesInWeek(f,i).map((g,P)=>g?_(Lr,{currentMonth:i,date:g,state:o},P):_("td",{},P))},f))})]})});var Rl=Ar.table`
  border-collapse: separate;
  border-spacing: 0px 4px;
`,kl=Ar.th`
  height: 36px;
`;import{forwardRef as Dl}from"react";import{useButton as Bl}from"react-aria";import{jsx as Fl}from"react/jsx-runtime";var _o=Dl(({className:e,buttonTheme:o="secondary",icon:t,variant:r="inline",...n},a)=>{let i=E(a),{buttonProps:s}=Bl(n,i),l={...s,className:e,buttonTheme:o,icon:t,variant:r};return Fl(F,{...l,className:e,ref:i})});import{jsx as no,jsxs as Vr}from"react/jsx-runtime";var Wr=zl(({className:e,...o},t)=>{let r=E(t),{locale:n}=El(),a=Ll({...o,locale:n,createCalendar:Al}),{calendarProps:i,prevButtonProps:s,nextButtonProps:l,title:p}=Ol(o,a,r);return Vr(Hl,{...i,className:e,ref:r,children:[Vr(Wl,{children:[no(_o,{...s,icon:Nl,variant:"ghost"}),no(m,{color:"gray12",tag:"h3",variant:"titleBase",children:p}),no(_o,{...l,icon:Vl,variant:"ghost"})]}),no(Nr,{state:a})]})});var Hl=Hr.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`,Wl=Hr.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;import{forwardRef as Gr}from"react";import{useLocale as Gl,useTimeField as Xl}from"react-aria";import{useTimeFieldState as _l}from"react-stately";import{jsx as $e}from"react/jsx-runtime";var Ul=Gr(({className:e,...o},t)=>{let r=E(t),{locale:n}=Gl(),a=_l({...o,locale:n}),{fieldProps:i}=Xl({...o,"aria-label":"Time Input","aria-labelledby":"beam-TimeInput"},a,r);return $e(to,{children:$e("div",{...i,"aria-label":`time-field-${i.id}`,"aria-labelledby":`time-field-${i.id}`,className:e,ref:r,children:a.segments.reduce((s,l,p)=>l.type!=="timeZoneName"?[...s,$e(eo,{segment:l,state:a},p)]:s,[])})})}),io=Gr(({width:e,...o},t)=>$e(Xo,{$width:e,children:$e(Ul,{...o,ref:t})}));import{Fragment as pc,jsx as D,jsxs as ve}from"react/jsx-runtime";var tc=_r(({className:e,container:o,granularity:t="minute",labelType:r="text",children:n,triggerProps:a,placeholder:i="Date Range",value:s,onChange:l,...p},c)=>{var j,Re;let d=E(c),[u,f]=jl(),g=M=>{f(M),l==null||l(M)},P=M=>{M.stopPropagation(),g(null)},T=Kl({...p,value:s??u,onChange:g,granularity:t}),{groupProps:v,startFieldProps:x,endFieldProps:b,buttonProps:w,calendarProps:R}=Jl({...p,"aria-label":"Date Range Picker","aria-labelledby":"beam-DateRangePicker"},T,d),{width:h="350px",color:I,...V}=a??{},U=()=>{var Z,ye;let M={...x,granularity:t},q={...b,granularity:t};switch(r){case"input":return ve(pc,{children:[D(oo,{...M}),D(m,{children:"-"}),D(oo,{...q})]});case"asChild":return n==null?void 0:n({startFieldProps:M,endFieldProps:q});case"text":default:return D(m,{color:"gray12",tag:"span",variant:"textSm",children:rc((Z=M.value)==null?void 0:Z.toDate(),(ye=q.value)==null?void 0:ye.toDate(),i)})}};return ve(Zl,{children:[D(Yl,{asChild:!0,children:ve(nc,{$color:I,$width:h,...V,...v,className:oc(V.className,v.className,e),ref:d,tabIndex:0,children:[D(ic,{children:U()}),D(F,{buttonTheme:"secondary",icon:Ql,onClick:P,variant:"inline"}),D(ac,{children:D(y,{color:"gray11",icon:ql})})]})}),ve(Qe,{container:o,sideOffset:5,children:[D(Wr,{...R}),ve(sc,{children:[D(pe,{label:"Start time",children:D(io,{onChange:M=>T.setTime("start",M),value:(j=T.timeRange)==null?void 0:j.start,width:"100%"})}),D(pe,{label:"End time",children:D(io,{onChange:M=>T.setTime("end",M),value:(Re=T.timeRange)==null?void 0:Re.end,width:"100%"})})]})]})]})}),eb=_r(({dateRange:e=[],onDateRangeChange:o,...t},r)=>{let n=e[0]?Xr(e[0].toISOString()):void 0,a=e[1]?Xr(e[1].toISOString()):void 0;return n=n??a,a=a??n,D(tc,{...t,onChange:s=>{let{start:l,end:p}=s??{};l&&p?o==null||o([l.toDate(),p.toDate()]):o==null||o([])},ref:r,value:n&&a?{start:n,end:a}:void 0})});var rc=(e,o,t="Date Range")=>{let r=e?ao(e,"MMM d, p"):void 0,n=o?ao(o,"MMM d, p"):void 0;return r&&n?e&&o&&ec(e,o)?`${ao(e,"MMM d, p")} - ${ao(o,"p")}`:`${r} - ${n}`:r?`After ${r}`:n?`Before ${n}`:t},nc=so.div`
  ${({theme:e,$width:o="fit-content",$color:t="gray12"})=>Uo`
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    overflow: hidden;
    background-color: ${e.colors.gray3};
    box-shadow: inset 0 0 0 1px ${e.colors.gray7};
    border-radius: 8px;
    width: ${o};
    color: ${e.colors[t]??t};
    height: 36px;
    justify-content: space-between;
    flex-shrink: 0;
    white-space: nowrap;
    overflow: hidden;

    &:hover {
      background-color: ${e.colors.gray4};
      box-shadow: inset 0 0 0 1px ${e.colors.gray8};
    }

    &:focus,
    &:focus-visible,
    &:focus-within {
      outline: unset;
      background-color: ${e.colors.gray4};
      box-shadow:
        inset 0 0 0 1px ${e.colors.blue9},
        0px 0px 0px 2px ${e.colors.blue7};
    }
  `}
`,ic=so.div`
  ${({theme:e})=>Uo`
      position: relative;
      display: flex;
      gap: 8px;
      align-items: center;
      box-sizing: border-box;
      width: fit-content;
      height: 36px;
      padding: 8px 12px;
      color: ${e.colors.gray12};
      flex: 1;
    `}
`,ac=so.div`
  ${({theme:e})=>Uo`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    white-space: nowrap;

    height: 34px;
    width: 34px;

    box-shadow: inset 1px 0 0 0 ${e.colors.gray7};

    &:hover {
      box-shadow: inset 1px 0 0 0 ${e.colors.gray8};
    }
  `}
`,sc=so.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  gap: 16px;
`;import{forwardRef as yc,useEffect as xc,useState as bc}from"react";import{useId as lc}from"react";import jo from"styled-components";import{faCheck as cc}from"@fortawesome/pro-regular-svg-icons";import{jsx as Ur,jsxs as uc}from"react/jsx-runtime";var dc=e=>{let o=lc(),{className:t,textValue:r,disabled:n,onSelect:a,id:i,checked:s,onCheckedChange:l,children:p}=e;return uc(mc,{className:t,disabled:n,onSelect:c=>{c.preventDefault(),a==null||a(c)},textValue:r,trailingIcon:s?cc:void 0,children:[Ur(fc,{htmlFor:i??o,onClick:c=>{c.stopPropagation()}}),Ur(gc,{checked:s??!1,id:i??o,onChange:c=>l==null?void 0:l(c.target.checked)}),p]})},jr=dc,mc=jo(Le)`
  position: relative;
  div:first-child {
    width: 100%;
    height: 100%;
  }
`,fc=jo.label`
  all: unset;
  position: absolute;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
`,gc=jo.input.attrs({type:"checkbox"})`
  display: none;
  position: absolute;
  width: 0;
  height: 0;
`;import{jsx as Zo,jsxs as hc}from"react/jsx-runtime";var yb=yc(({children:e,container:o,triggerAsChild:t,values:r=[],onValuesChange:n,options:a=[]},i)=>{let s=r.reduce((d,u)=>({...d,[u]:{value:u,checked:!0}}),{}),[l,p]=bc();xc(()=>{if(l){let d=Object.entries(l).reduce((u,[f,{checked:g}])=>g?[...u,f]:u,[]);n==null||n(d)}},[l]);let c=d=>u=>{p(f=>({...f??s,[d]:{value:d,checked:u}}))};return hc(ze,{children:[Zo(re,{asChild:t,children:e}),Zo(Oe,{container:o,minWidth:"320px",ref:i,children:a.map(({value:d,children:u},f)=>{var g;return Zo(jr,{checked:!!((g=l==null?void 0:l[d])!=null&&g.checked)||r.includes(d),id:d,onCheckedChange:c(d),children:u},f)})})]})});import{forwardRef as Pc,useState as Zr}from"react";import Yo from"styled-components";import{Close as Yr,Root as Tc,Trigger as Ic}from"@radix-ui/react-popover";import{jsx as N,jsxs as po}from"react/jsx-runtime";var vb=Pc(({container:e,asChild:o,children:t,min:r,max:n,unit:a,values:i=[],onValuesChange:s,triggerProps:l={}},p)=>{let c=a??"";if(r!==void 0&&n!==void 0&&r>n)throw Error("min prop must be less max prop");if(i[0]!==void 0&&i[1]!==void 0&&i[0]>i[1])throw Error("values prop is not ordered correctly");let[d,u]=Zr(),[f,g]=Zr(),P=()=>{let h=Number.isNaN(d)?void 0:d??i[0],I=Number.isNaN(f)?void 0:f??i[1],V=ue(h,r,n)?h:i[0],U=ue(I,r,n)?I:i[1],j=V!==void 0&&U!==void 0?[Math.min(V,U),Math.max(V,U)]:[V,U];u(void 0),g(void 0),s==null||s(j)},T=()=>{u(void 0),g(void 0),s==null||s([])},v=()=>{let h=i[0]??r,I=i[1]??n;return h=ue(h,r,n)?h:r,I=ue(I,r,n)?I:n,h===r&&I===n&&h===I&&h!==void 0?`${h} ${a}`:h===r&&I!==void 0?`< ${I}${c?` ${c}`:""}`:h!==void 0&&I===n?`> ${h}${c?` ${c}`:""}`:h!==void 0&&I!==void 0?`${h} - ${I}${c?` ${c}`:""}`:"Duration"},x=d??i[0],b=f??i[1];x=Number.isNaN(x)?void 0:x,b=Number.isNaN(b)?void 0:b;let w=x===void 0||ue(x,r,n)&&(b===void 0||x<=b),R=b===void 0||ue(b,r,n)&&(x===void 0||x<=b);return po(Tc,{children:[N(Ic,{asChild:!0,children:o?t:N(Ee,{...l,children:N(Cc,{children:v()})})}),po(Qe,{container:e,minWidth:"320px",ref:p,sideOffset:5,children:[po(At,{children:[N(pe,{label:`Min duration${c?` (${c})`:""}`,children:N(Kr,{error:!w,onChange:h=>u(parseInt(h.target.value)),type:"number",value:x??""})}),N(pe,{label:`Max duration${c?` (${c})`:""}`,children:N(Kr,{error:!R,onChange:h=>g(parseInt(h.target.value)),type:"number",value:b??""})})]}),po(Sc,{children:[N(Yr,{asChild:!0,children:N(B,{buttonTheme:"secondary",onClick:T,variant:"outline",children:"Clear"})}),N(Yr,{asChild:!0,children:N(B,{onClick:P,children:"Confirm"})})]})]})]})});var ue=(e,o,t)=>e!==void 0&&o!==void 0&&t!==void 0?o<=e&&e<=t:!0,Cc=Yo.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: max-content;
`,Kr=Yo(Io)`
  /* Chrome, Safari, Edge, Opera */
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  [type="number"] {
    -moz-appearance: textfield;
    appearance: textfield;
  }
`,Sc=Yo.div`
  display: flex;
  justify-content: right;
  gap: 8px;
  align-self: stretch;
`;import{createContext as wc,forwardRef as Jr,useContext as $c,useMemo as vc,useState as Rc}from"react";import{Root as kc,Item as Mc}from"@radix-ui/react-radio-group";import qr,{css as Qr}from"styled-components";import{jsx as lo}from"react/jsx-runtime";var en=wc({size:"lg",variant:"gradient"}),Eb=Jr(({size:e="lg",variant:o="gradient",textVariant:t,value:r,onValueChange:n,...a},i)=>{let[s,l]=Rc();return lo(en.Provider,{value:vc(()=>({size:e,variant:o,textVariant:t,value:r??s}),[r,e,t,s,o]),children:lo(Dc,{...a,"data-size":e,"data-variant":o,onValueChange:p=>{l(p),n==null||n(p)},ref:i,value:r??s})})}),Ob=Jr(({children:e,...o},t)=>{let{size:r="lg",variant:n="gradient",value:a,textVariant:i}=$c(en),s=o.value===a;return lo(Bc,{$typography:i,...o,asChild:!0,"data-size":r,"data-variant":n,ref:t,children:lo(B,{buttonTheme:s?"primary":"secondary",variant:s?"solid":"ghost",children:e})})});var Dc=qr(kc)`
  ${({theme:e})=>Qr`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 4px;
    box-sizing: border-box;
    gap: 2px;
    background-color: ${e.colors.gray3};
    box-shadow:
      ${e.shadows.base},
      inset 0 0 0 1px ${e.colors.gray7};
    border-radius: 8px;
    width: fit-content;

    &[data-size="sm"] {
      height: 36px;
    }

    &[data-size="lg"] {
      height: 48px;
    }
  `}
`,Bc=qr(Mc)`
  ${({theme:e,$typography:o})=>Qr`
      && {
        display: inline-flex;
        height: 100%;

        &[data-state="checked"][data-variant="gradient"] {
          background: linear-gradient(
            180deg,
            ${$(e.colors.blue9,1)} 0%,
            ${$(e.colors.blue9,.64)} 100%
          );
          box-shadow: ${e.shadows.base};
          backdrop-filter: blur(8px);

          &:hover {
            background: linear-gradient(
              180deg,
              ${$(e.colors.blue10,1)} 0%,
              ${$(e.colors.blue10,.64)} 100%
            );
          }
        }

        ${o?e.styleSet[o]:void 0};
      }
    `}
`;export{hd as Avatar,Rd as Badge,Du as Banner,fi as BoxedIcon,ny as BreadcrumbItem,iy as Breadcrumbs,B as Button,Zd as ButtonGroup,gg as Callout,Zp as Chart,Cr as ChartLegend,gy as ChartNumericTooltip,wr as ChartTooltip,_f as Checkbox,rr as CodeBox,iu as CodeWindow,or as Copier,ul as DateInput,eb as DateTimePicker,xm as Drawer,At as Form,pe as FormControl,y as Icon,F as IconButton,Io as Input,fd as Link,ze as Menu,Oe as MenuContent,ho as MenuDropdownTrigger,Ee as MenuDropdownTriggerImpl,Em as MenuGroup,Le as MenuItem,re as MenuTrigger,gt as Modal,tm as ModalBody,rm as ModalFooter,dm as ModalHeader,yb as MultiSelectDropdown,fu as Pagination,xf as Pill,bu as Progress,Of as RadioGroup,Lf as RadioItem,vf as Searchbar,vt as Select,Og as Sidebar,Cu as Step,rf as Table,af as TableBody,pf as TableCell,nf as TableHead,sf as TableRow,Wu as TabsManager,Rf as Textarea,Gn as ThemeProvider,io as TimeInput,vb as TimeRangeDropdown,Eb as ToggleSwitch,Ob as ToggleSwitchItem,Et as Tooltip,m as Typography,mo as defaultTheme,Yu as defaultToastContainerProps,Ku as toastContainerStyleSheet,be as useTheme};
